import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Box, Card, CardContent, TextField, Typography } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';

export interface SimpleNotesRef {
  getNoteContent: () => string;
}

interface SimpleNotesProps {
  initialContent: string;
}

const SimpleNotes = forwardRef<SimpleNotesRef, SimpleNotesProps>(({ initialContent }, ref) => {
  const [noteContent, setNoteContent] = useState(initialContent);

  useImperativeHandle(ref, () => ({
    getNoteContent: () => noteContent,
  }));

  return (
    <Card>
      <CardContent>
        <Box display='flex' alignItems='center' sx={{ mt: 1, mb: 2 }}>
          <EditNoteIcon color='primary' sx={{ fontSize: '24px !important', fontWeight: '700 !important' }} />
          <Typography variant='h5' color='primary' sx={{ ml: 1, mb: 0 }}>
            Notes
          </Typography>
        </Box>
        <TextField
          multiline
          rows={4}
          fullWidth
          variant='outlined'
          value={noteContent}
          onChange={e => setNoteContent(e.target.value)}
          placeholder='Add a note...'
        />
      </CardContent>
    </Card>
  );
});

SimpleNotes.displayName = 'SimpleNotes';

export default SimpleNotes;
